<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="row">
        <div class="col-md-6">
          <h5 class="panel-title">Current Batch Transactions</h5>
        </div>
        <div class="col-md-6 text-right">
          <div class="btn-group">
            <button class="btn btn-default btn-xs" @click="params.postedTransactionsHidden = true" v-if="!params.postedTransactionsHidden" v-tooltip title="Hide Posted Transactions"><span class="glyphicon glyphicon-remove-sign"></span></button>
            <button class="btn btn-default btn-xs" @click="params.postedTransactionsHidden = false" v-if="params.postedTransactionsHidden" v-tooltip title="Show Posted Transactions"><span class="glyphicon glyphicon-ok-sign"></span></button>
          </div>
          <div class="btn-group">
            <button class="btn btn-default btn-xs" @click="toggleVisibility()" v-show="visible" v-tooltip title="Hide transactions"><span class="glyphicon glyphicon-chevron-up"></span></button>
            <button class="btn btn-default btn-xs" @click="toggleVisibility()" v-show="!visible" v-tooltip title="Show transactions"><span class="glyphicon glyphicon-chevron-down"></span></button>
          </div>
        </div>
      </div>
    </div><!-- .panel-heading -->
    <table class="table table-bordered table-hover table-condensed table-compact" v-show="visible">
      <thead>
        <tr>
          <th class="text-center" v-if="amountFinderStarted">
            <button class="btn btn-xs text-warning" type="button"
              @click="toggleAllSelection()"
              v-tooltip title="Select or unselect all transactions"
              >
              <span title="Select all" class="glyphicon glyphicon-ok" v-if="!isAllSelected" v-cloak></span>
              <span title="Unselect all" class="glyphicon glyphicon-remove" v-if="isAllSelected" v-cloak></span>
            </button>
          </th>
          <th class="col-md-2 text-center" st-sort="batchNumber">Batch #</th>
          <th class="col-md-1 text-center" st-sort="trxDateCreated" @click="toggleSort('datetime')">
            <i class="fa fa-fw fa-sort" v-show="!getSortMethod('datetime')"></i>
            <i class="fa fa-fw fa-sort-asc" v-show="'asc' === getSortMethod('datetime')"></i>
            <i class="fa fa-fw fa-sort-desc" v-show="'desc' === getSortMethod('datetime')"></i>
            Trx Date
          </th>
          <th class="col-md-1 text-center" st-sort="trxDocumentNumber" @click="toggleSort('documentNumber')">
            <i class="fa fa-fw fa-sort" v-show="!getSortMethod('documentNumber')"></i>
            <i class="fa fa-fw fa-sort-asc" v-show="'asc' === getSortMethod('documentNumber')"></i>
            <i class="fa fa-fw fa-sort-desc" v-show="'desc' === getSortMethod('documentNumber')"></i>
            Doc#
          </th>
          <th class="col-md-2" st-sort="trxMethod" @click="toggleSort('methodLabel')">
            <i class="fa fa-fw fa-sort" v-show="!getSortMethod('methodLabel')"></i>
            <i class="fa fa-fw fa-sort-asc" v-show="'asc' === getSortMethod('methodLabel')"></i>
            <i class="fa fa-fw fa-sort-desc" v-show="'desc' === getSortMethod('methodLabel')"></i>
            Method
            <select @click.stop v-model="filters.group">
              <option :value="null">All</option>
              <option v-for="(label, key) in groupFilters" :key="key" :value="label">{{ label }}</option>
            </select>
          </th>
          <th class="col-md-4" st-sort="customerName" @click="toggleSort('customerName')">
            <i class="fa fa-fw fa-sort" v-show="!getSortMethod('customerName')"></i>
            <i class="fa fa-fw fa-sort-asc" v-show="'asc' === getSortMethod('customerName')"></i>
            <i class="fa fa-fw fa-sort-desc" v-show="'desc' === getSortMethod('customerName')"></i>
            Customer
          </th>
          <th class="col-md-1 text-right">
            <!-- Order$/ -->AuthNet$
          </th>
          <th class="col-md-1 text-right" st-sort="trxAmount" @click="toggleSort('amount')">
            <i class="fa fa-fw fa-sort" v-show="!getSortMethod('amount')"></i>
            <i class="fa fa-fw fa-sort-asc" v-show="'asc' === getSortMethod('amount')"></i>
            <i class="fa fa-fw fa-sort-desc" v-show="'desc' === getSortMethod('amount')"></i>
            Amount$
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(trx, key) in sortedAndFilteredCurrentTransactions" :key="`${key}:${trx.paymentId}`" :class="{'active' : trxIsPosted(trx)}" @click="toggleSelection(trx)">
          <td class="text-center" v-if="amountFinderStarted"><span class="glyphicon glyphicon-ok" v-if="isSelected(trx)"></span></td>
          <td class="text-center">
            <i class="fa fa-fw fa-book text-success" v-if="!!trxIsPosted(trx) && !isEditingBatchNumber(trx)" v-tooltip data-tooltip-placement="right" data-tooltip-html="true" title="Posted Transaction<br/>To move transaction to another batch, unreconcile first."></i>
            <i class="fa fa-fw fa-exclamation text-danger" v-if="!trxIsPosted(trx) && !trxIsInEditMode(trx) && !isEditingBatchNumber(trx)" v-tooltip data-tooltip-placement="right" title="Unposted Transaction"></i>
            <span v-if="!isEditingBatchNumber(trx)">
              <template v-if="amountFinderStarted || trxIsPosted(trx)">
                {{ trx.batchNumber }}
              </template>
              <a v-else @click.prevent @dblclick.prevent.stop="editBatchNumber(trx)" href="#">
                {{ trx.batchNumber }}
              </a>
            </span>
            <input
              class="--form-control text-center --input-sm table-body-item__editor bn-item-"
              type="text"
              v-if="isEditingBatchNumber(trx) && !trxIsPosted(trx)"
              v-model="innerEdit.batchNumber.value"
              :ref="`current-trx-bn-${trx.paymentId}`"
              @keypress.enter="saveBatchNumber(trx, $event)"
              @keyup.esc.prevent="cancelEditBatchNumber(trx)"
              />
            <div class="btn-group" v-if="!trxIsPosted(trx) && !trxIsInEditMode(trx) && !isEditingBatchNumber(trx)" v-tooltip title="Adjust BN by (+/-) number of days">
              <button class="btn btn-default btn-xs" @click.stop="adjustBatchNumber(trx, 1)"><i class="fa fa-fw fa-plus"></i></button>
              <button class="btn btn-default btn-xs" @click.stop="adjustBatchNumber(trx, -1)"><i class="fa fa-fw fa-minus"></i></button>
              <button class="btn btn-default btn-xs dropdown-toggle" data-toggle="dropdown"><i class="fa fa-fw fa-caret-down"></i></button>
              <ul class="dropdown-menu">
                <li><a @click.stop="adjustBatchNumber(trx, -1)"><i class="fa fa-fw fa-minus"></i> 1 day</a></li>
                <li><a @click.stop="adjustBatchNumber(trx, -2)"><i class="fa fa-fw fa-minus"></i> 2 days</a></li>
                <li><a @click.stop="adjustBatchNumber(trx, -3)"><i class="fa fa-fw fa-minus"></i> 3 days</a></li>
                <li><a @click.stop="adjustBatchNumber(trx, -4)"><i class="fa fa-fw fa-minus"></i> 4 days</a></li>
              </ul>
            </div>
          </td>
          <td class="text-center">{{ trx.date | format('MM/DD/YYYY') }} {{ trx.dateCreated | format('HH:mm:ss') }}</td>
          <td class="text-center">
            <router-link v-if="trxIsPayment(trx) && trx.documentNumber" target="_blank" :to="`/admin/sales_order.php?oID=${trx.documentNumber}&action=view`"><i class="fa fa-fw fa-external-link"></i></router-link>
            {{ trxDocumentNumber(trx) }}
          </td>
          <td>
            <router-link v-if="trxIsPayment(trx) && trx.paymentId" target="_blank" :to="`/admin/sales-payment/view/${trx.paymentId}`"><i class="fa fa-fw fa-external-link"></i></router-link>
            {{ trxMethod(trx) }}
          </td>
          <td>{{ trx.customerName }}</td>
          <td class="text-right">
            <div v-show="trx.paymentId
              && (
                (
                  orderHasMultiplePayment(trx.documentNumber)
                  && orderTotal(trx.documentNumber) != trx.amount
                )
                || orderPayment(trx.documentNumber) != trx.amount
                || (
                  hasPaymentAuthNet(trx.paymentId)
                  && paymentAuthNet(trx.paymentId) != trx.amount
                )
              )">
              <!-- <span title="Order Total">
                <money currencySign="" :value="orderTotal(trx.documentNumber)" v-if="orderHasMultiplePayment(trx.documentNumber) && orderTotal(trx.documentNumber) != trx.amount"></money>
                <span v-else>-.--</span> /
              </span> -->
              <!-- <span title="Order Total Payment">
                <money currencySign="" :value="orderPayment(trx.documentNumber)" v-if="orderPayment(trx.documentNumber) != trx.amount"></money>
                <span v-else>-.--</span> /
              </span> -->
              <span title="AuthNet Amount Sent">
                <money currencySign="" :value="paymentAuthNet(trx.paymentId)" v-if="hasPaymentAuthNet(trx.paymentId) && paymentAuthNet(trx.paymentId) != trx.amount"></money>
                <span v-else>-.--</span>
              </span>
            </div>
          </td>
          <td class="text-right" :class="{'text-danger': ['refund', 'nsf'].indexOf(trx.type) >= 0}"><money currencySign="" :value="trx.amount + trx.bankFee"></money></td>
        </tr>
      </tbody>
    </table>
    <div class="panel-footer">
      <div class="row">
        <div class="col-md-6 text-right" v-if="amountFinderStarted">
          <strong>Selected:</strong> {{ totalSelected }}
        </div>
        <div class="col-md-3 text-right" :class="{'col-md-offset-6': !amountFinderStarted}">
          <strong>Total Items:</strong> {{ isFiltered ? totalFilteredTransactions : totalTransactions }}
        </div>
        <div class="col-md-3 text-right">
          <strong>Pay $ Total: </strong>
          <span v-if="!amountFinderStarted"><money currencySign="" :value="sumOfFilteredTransactions"></money></span>
          <span v-if="amountFinderStarted"><money currencySign="" :value="sumOfAllSelected"></money></span>
        </div>
      </div>
    </div><!-- .panel-footer -->
  </div><!-- .panel -->
</template>

<script>
  import _ from 'lodash'
  import { mapState, mapGetters } from 'vuex'
  import { format } from '@/plugin/filter/date'
  import moment from 'moment'
  import BatchMixin from '../../mixin/batch'
  import Money from '@/plugin/element/money'
  import Tooltip from '@/plugin/directive/tooltip'

  export default {
    name: 'current-transactions',
    data() {
      return {
        params: {
          postedTransactionsHidden: null
        },
        visible: true,
        sorters: {
          amount: 'desc'
        },
        filters: {
          method: null,
          group: null
        },
        batchNumberSkipWeekends: false,
        enableFilterByMethod: false,
        innerEdit: {
          batchNumber: {
            trx: null,
            active: false,
            value: null,
            oldValue: null
          }
        }
      }
    },
    created() {
      if (this.enableFilterByMethod) {
        this.filters.method = localStorage['vue.admin.accounting.current-transactions.filters.method'] || null
      } else {
        this.filters.method = null
      }
      this.filters.group = localStorage['vue.admin.accounting.current-transactions.filters.group'] || null
    },
    watch: {
      'filters.method'(val) {
        if (null === val || undefined === val) {
          if (localStorage['vue.admin.accounting.current-transactions.filters.method']) {
            delete localStorage['vue.admin.accounting.current-transactions.filters.method']
          }
        } else {
          localStorage['vue.admin.accounting.current-transactions.filters.method'] = val
        }
        this.unselectAllTransactions()
        this.selectAllFilteredTransactions()
      },
      'filters.group'(val) {
        if (null === val || undefined === val) {
          if (localStorage['vue.admin.accounting.current-transactions.filters.group']) {
            delete localStorage['vue.admin.accounting.current-transactions.filters.group']
          }
        } else {
          localStorage['vue.admin.accounting.current-transactions.filters.group'] = val
        }
        this.unselectAllTransactions()
        this.selectAllFilteredTransactions()
      },
      amountFinderStarted(val) {
        if (!val) {
          return
        }

        _.chain(this.selectedTransactions)
          .filter((trx) => {
            return !_.includes(this.sortedAndFilteredCurrentTransactions, trx)
          })
          .map((trx) => {
            this.unselectTransaction(trx)

            return trx
          })
          .commit()
      }
    },
    computed: {
      ...mapState('paymentReconciliation/batch', {
        batchNumber: 'batchNumber'
      }),
      ...mapGetters('paymentReconciliation/batch', {
        methodToLabelMap: 'methodToLabelMap',
        orderTotal: 'orderTotal',
        orderPayment: 'orderPayment',
        orderHasMultiplePayment: 'orderHasMultiplePayment',
        paymentAuthNet: 'paymentAuthNet',
        hasPaymentAuthNet: 'hasPaymentAuthNet',
      }),
      ...mapState('paymentReconciliation/amountFinder', {
        currentTransactions: 'currentTransactions',
        selectedTransactions: 'selectedCurrentTransactions'
      }),
      ...mapGetters('paymentReconciliation/amountFinder', {
        amountFinderStarted: 'started'
      }),
      sumOfAllTransactions() {
        return _.sumBy(this.currentTransactions, (trx) => {
          return this.trxAmount(trx)
        })
      },
      sumOfAllSelected() {
        return _.sumBy(this.selectedTransactions, (trx) => {
          return this.trxAmount(trx)
        })
      },
      sumOfFilteredTransactions() {
        return _.sumBy(this.sortedAndFilteredCurrentTransactions, (trx) => {
          return this.trxAmount(trx)
        })
      },
      isAllSelected() {
        return this.totalSelected === this.totalTransactions
      },
      totalSelected() {
        return this.selectedTransactions.length
      },
      totalTransactions() {
        return this.currentTransactions.length
      },
      totalFilteredTransactions() {
        return this.sortedAndFilteredCurrentTransactions.length
      },
      isAllFilteredSelected() {
        return ! (_.difference(
          this.sortedAndFilteredCurrentTransactions, this.selectedTransactions
        ).length > 0)
      },
      isFiltered() {
        return !!this.filters.method || !!this.filters.group
      },
      sortedAndFilteredCurrentTransactions() {
        let transactions = this.currentTransactions
        transactions = this.sortTransactions(transactions)
        transactions = this.filterTransactions(transactions)
        return transactions
      },
      methodFilters() {
        return _.chain(this.currentTransactions)
          .map((trx) => {
            let label = trx.methodName
            if (trx.methodClass) {
              label += ' ' + trx.methodClass
            }
            return label
          })
          .values()
          .thru((labels) => {
            const val = localStorage['vue.admin.accounting.current-transactions.filters.method']
            if (val) {
              labels.push(val)
            }
            return labels
          })
          .uniq()
          .sortBy((item) => {
            return [
              'Credit Card Visa',
              'Credit Card Master Card',
              'Credit Card Discover',
              'Credit Card American Express',
              'Fax Check',
              'NSF ACH',
              'NSF Check',
              'Check / Money Order',
              'Wire Transfer',
              'Paypal',
              'Cash',
              'Credit Card',
              'Check',
              'Open Account',
              'Customer Credit',
              'Account Debit',
            ].indexOf(item)
          })
          .map((item) => {
            if (-1 === item.indexOf('Credit Card')) {
              return item
            }

            return item.substring(12)
          })
          .value()
      },
      groupFilters() {
        return [
          'Credit Card',
          'ACH',
          'Checks & Money Order',
          'Wire Transfer',
          'Paypal',
          'Cash',
        ]
      }
    },
    methods: {
      toggleVisibility() {
        this.visible = !this.visible
      },
      toggleSelection(trx) {
        if (!this.amountFinderStarted) {
          return
        }

        if (this.isSelected(trx)) {
          this.unselectTransaction(trx)
        } else {
          this.selectTransaction(trx)
        }
      },
      selectTransaction(trx) {
        this.$store.dispatch('paymentReconciliation/amountFinder/selectCurrentTransaction', trx)
      },
      unselectTransaction(trx) {
        this.$store.dispatch('paymentReconciliation/amountFinder/unselectCurrentTransaction', trx)
      },
      isSelected(trx) {
        return _.indexOf(this.selectedTransactions, trx) >= 0
      },
      toggleAllSelection() {
        if (this.isFiltered) {
          if (this.isAllFilteredSelected) {
            this.unselectFilteredTransactions()
          } else {
            this.selectFilteredTransactions()
          }
        } else {
          if (this.isAllSelected) {
            this.unselectAllTransactions()
          } else {
            this.selectAllTransactions()
          }
        }
      },
      selectAllTransactions() {
        this.$store.dispatch('paymentReconciliation/amountFinder/selectAllCurrentTransaction')
      },
      unselectAllTransactions() {
        this.$store.dispatch('paymentReconciliation/amountFinder/unselectAllCurrentTransaction')
      },
      selectAllFilteredTransactions() {
        _.each(this.sortedAndFilteredCurrentTransactions, (trx) => {
          this.selectTransaction(trx)
        })
      },
      unselectAllFilteredTransactions() {
        _.each(this.sortedAndFilteredCurrentTransactions, (trx) => {
          this.unselectTransaction(trx)
        })
      },
      selectFilteredTransactions() {
        _.each(this.sortedAndFilteredCurrentTransactions, (trx) => {
          this.selectTransaction(trx)
        })
      },
      unselectFilteredTransactions() {
        _.each(this.sortedAndFilteredCurrentTransactions, (trx) => {
          this.unselectTransaction(trx)
        })
      },
      trxIsInEditMode(trx) {
        return !_
          .chain(this.params.transactionInEditMode)
          .filter((trxInEditMode) => {
            return trxInEditMode === trx
          })
          .isEmpty()
          .value()
      },
      editingTransaction(trx) {
        this.params.transactionInEditMode.push(trx)
      },
      doneEditingTransaction(trx) {
        this.params.transactionInEditMode = _.filter(this.params.transactionInEditMode, (trxInEditMode) => {
          return trxInEditMode !== trx
        })
      },
      adjustBatchNumber(trx, adjustmentInDay) {
        if (isNaN(trx.batchNumber)) {
          this.$alertify.error(''
            + 'Unable to determine the next batch number.  Expecting a batch '
            + 'number in numeric format but provided with ' + trx.batchNumber + '.'
          )
          return
        }
        if (isNaN(adjustmentInDay)) {
          this.$alertify.error(''
            + 'Adjustment in day provided is invalid.  Expecting a numeric value '
            + 'but provided with ' + adjustmentInDay + '.'
          )
          return
        }

        const bn = parseInt(trx.batchNumber)
        if (! /^[0-9]{6}$/.test(bn)) {
          this.$alertify.error('Invalid batch number format.  Batch number should be in format YYMMDD.')
          return
        }

        const yy = bn.toString().substring(0, 2)
        const mm = bn.toString().substring(2, 4)
        const dd = bn.toString().substring(4, 6)

        let dt = moment(mm + "/" + dd + "/" + yy, "MM/DD/YY")

        dt.add(adjustmentInDay, 'days')

        if (this.batchNumberSkipWeekends) {
          if (6 === dt.isoWeekday()) { // Saturday
            if (adjustmentInDay > 0) {
              dt.add(2, 'days')
            } else if (adjustmentInDay < 0) {
              dt.add(-1, 'days')
            }
          } else if (7 === dt.isoWeekday()) { // Sunday
            if (adjustmentInDay > 0) {
              dt.add(1, 'days')
            } else if (adjustmentInDay < 0) {
              dt.add(-2, 'days')
            }
          }
        }

        trx.batchNumber = dt.format('YYMMDD')

        this.applyNewBatchNumber(trx, trx.batchNumber, this.batchNumber)
      },
      onBatchNumberUpdate(trx) {
        if (this.batchNumber === trx.batchNumber) {
          return
        }

        this.applyNewBatchNumber(trx, trx.batchNumber, this.batchNumber)
      },
      async applyNewBatchNumber(trx, newVal, oldVal) {
        if (newVal === oldVal) {
          return
        }

        await this.$store.dispatch('paymentReconciliation/batch/rebatchTransaction', {transaction: trx, newVal, oldVal}).then(() => {
          this.$store.dispatch('paymentReconciliation/batch/fetch')
        })
      },
      toggleSort(col) {
        let val = this.sorters[col]

        this.sorters = {}

        if (val) {
          if ('asc' === val) {
            this.$set(this.sorters, col, 'desc')
          } else if ('desc' === val) {
            this.$set(this.sorters, col, 'asc')
          }
        } else {
          this.$set(this.sorters, col, 'asc')
        }
      },
      getSortMethod(col) {
        return this.sorters[col]
      },
      sortTransactions(transactions) {
        if (_.isEmpty(this.sorters)) {
          return transactions
        }

        let columns = _.keys(this.sorters)
        let orders = _.values(this.sorters)

        if (1 === columns.length) {
          let methodLabelIndex = _.indexOf(columns, 'methodLabel')
          if (methodLabelIndex >= 0) {
            columns.push('amount')
            if ('desc' === orders[methodLabelIndex]) {
              orders.push('asc')
            } else {
              orders.push('desc')
            }
          }
        }

        columns = _.map(columns, (col) => {
          if ('methodLabel' !== col) {
            return col
          }
          return (item) => {
            return [
              'Visa',
              'Master Card',
              'Discover',
              'American Express',
              'Fax Check',
              'NSF ACH',
              'NSF Check',
              'Check / Money Order',
              'Wire Transfer',
              'Paypal',
              'Cash',
              'Credit Card',
              'Check',
              'Open Account',
              'Customer Credit',
              'Account Debit',
            ].indexOf(this.trxMethod(item))
          }
        })

        columns = _.map(columns, (col) => {
          if ('datetime' !== col) {
            return col
          }
          return (item) => {
            let date = item.date
            let time = moment(item.dateCreated, 'YYYY-MM-DD HH:mm:ss').format('HH:mm:ss')
            return `${date} ${time}`
          }
        })

        return _.chain(transactions).orderBy(columns, orders).value()
      },
      filterTransactions(transactions) {
        return _.chain(transactions)
          .filter((trx) => {
            if (!this.filters.method) {
              return true
            }

            return trx.methodName === this.filters.method || trx.methodClass === this.filters.method
          })
          .filter((trx) => {
            if (!this.filters.group) {
              return true
            }
            if ('All' === this.filters.group) {
              return true
            }

            let keep = false
            switch (this.filters.group) {
              case 'Credit Card':
                keep = trx.methodName === 'Credit Card'
                break
              case 'ACH':
                keep = _.indexOf(['Fax Check', 'Account Debit'], trx.methodName) >= 0
                break
              case 'Checks & Money Order':
                keep = _.indexOf(['Check', 'Check / Money Order'], trx.methodName) >= 0
                break
              case 'Wire Transfer':
                keep = trx.methodName === 'Wire Transfer'
                break
              case 'Paypal':
                keep = trx.methodName === 'Paypal'
                break
              case 'Cash':
                keep = trx.methodName === 'Cash'
                break
            }

            return keep
          })
          .value()
      },
      transactionTimeCreated(trx) {
        moment(trx.dateCreated).format('hh:mm:ss')
      },
      isEditingBatchNumber(trx) {
        return null !== trx
          && this.innerEdit.batchNumber.trx === trx
          && this.innerEdit.batchNumber.active
      },
      editBatchNumber(trx) {
        if (this.amountFinderStarted || this.trxIsPosted(trx)) {
          return
        }

        this.innerEdit.batchNumber.trx = trx
        this.innerEdit.batchNumber.active = true
        this.innerEdit.batchNumber.value = trx.batchNumber
        this.innerEdit.batchNumber.oldValue = trx.batchNumber

        this.$nextTick(() => {
          let trxId = null
          switch (trx.type) {
            case 'payment':
              trxId = trx.paymentId
              break
            case 'refund':
              trxId = trx.refundId
              break
          }
          if (trxId) {
            this.$refs[`current-trx-bn-${trxId}`][0].focus()
          }
        })
      },
      async saveBatchNumber(trx) {
        await this.applyNewBatchNumber(
          trx,
          this.innerEdit.batchNumber.value,
          this.innerEdit.batchNumber.oldValue
        )
        this.cancelEditBatchNumber(trx)
      },
      cancelEditBatchNumber(trx) {
        if (this.innerEdit.batchNumber.trx !== trx) {
          return
        }
        this.innerEdit.batchNumber.trx = null
        this.innerEdit.batchNumber.active = false
        this.innerEdit.batchNumber.value = null
      }
    },
    components: {
      Money
    },
    directives: {
      tooltip: Tooltip
    },
    filters: {
      format
    },
    mixins: [
      BatchMixin
    ]
  }
</script>
